import React from 'react';
import WithdrawProgress from '../../components/Transactions/WithdrawProgress';

const TransactionWithdrawPage = () => {
	return <WithdrawProgress />;
};

export default TransactionWithdrawPage;
